import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-tryout-not-required-custom-questions',
  templateUrl: './tryout-not-required-custom-questions.component.html',
  styleUrls: ['./tryout-not-required-custom-questions.component.css']
})
export class TryoutNotRequiredCustomQuestionsComponent implements OnInit {
  @Input() NoOfTotalNotRequiredQuestions: string;
  @Output() filterQuestionEvent = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  filterQuestionListing(value) {
    this.filterQuestionEvent.emit(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/tryout/components/tryout-not-required-custom-questions/tryout-not-required-custom-questions.component.ts